export const tradingContest = {
  cyjyds: "Участвуйте в торговом турнире",
  jsjxmh: "Открывайте сюрприз-боксы и выигрывайте супер-призы!",
  hdsj: "Время проведения",
  mrjxsj: "Ежедневно с 00:00 до 23:59 UTC+8.",
  ckxxgz: "Посмотреть детальные правила",
  wdjj: "Мой призовой фонд",
  jlkj: "До розыгрыша",
  cjjc: "Супер-призовой фонд",
  jjmrzj: "Призовой фонд увеличивается ежедневно",
  kqxjd: "Новый этап — больше наград",
  dyjd: "Первый этап",
  dejd: "Второй этап",
  dsjd: "Третий этап",
  dsijd: "Четвёртый этап",
  jrmhjj: "Призовой фонд сегодняшних боксов",
  syjj: "Оставшийся призовой фонд",
  yblqje: "Сумма уже полученных наград",
  tjmh: "Особый бокс",
  yjmh: "Бокс 1-го уровня",
  ejmh: "Бокс 2-го уровня",
  sjmh: "Бокс 3-го уровня",
  jj: "Приз:",
  gs: "шт",
  djdkrymh: "Нажмите, чтобы открыть любой сюрприз-бокс",
  kydk: "Сегодня вы можете открыть",
  jxmh: "сюрприз-бокс(ов)",
  dkmhxyxx: "Для открытия одного бокса требуется {amount} звёзд.",
  xzyyxx: "У вас сейчас {amount} звёзд",
  xxqlsj: "Время сброса звёзд: {date} (получите боксы до сброса)",
  wdxx: "Мои звёзды",
  xxhq: "Как получить звёзды",
  hqxxtj: "Способы получения звёзд",
  yxhysxf: "Бессрочный контракт: 1 звезда за каждые {amount} USDT комиссии",
  qqhysxf: "Опционы: 1 звезда за каждые {amount} USDT объёма",
  youxihysxf: "GameFi: 1 звезда за каждые {amount} USDT объёма",
  gxhd: "Поздравляем! Вы получили",
  jlydrzh: "Награда зачислена на ваш счёт «{account}»",
  qzjzhck: "Перейти к просмотру на счёте GameFi",
  bwcjjc: "Супер-призовой фонд BiKing",
  qmxjyds: "Турнир всех звёзд",
  gbgbyb: "Осмелитесь рискнуть?",
  bwcjjcdnn: "Супер-фонд BiKing: {amount}% ежедневно в боксах — забирайте!",
  cjjcqmxjys: "Супер-фонд турнира всех звёзд: {amount}% ежедневно в боксах,",
  syyxbd: "Один клик — и малая ставка может принести большую победу!",
  zgtk: "Хотите быть первым? Деритесь до конца!",
  zhyz: "Ежедневно {amount}% фонда накапливается до финала,",
  dfdj: "Кто сорвёт главный приз BiKing?",
  gsjj: "В супер-турнире всех звёзд BiKing собираются лучшие трейдеры,",
  qmxpk: "Все звёзды сразятся по-настоящему!",
  jymh: "Торгуйте, открывайте боксы, поднимайтесь в рейтинге — станьте королём арены BiKing!",
  zzbzy: "Бессрочные контракты, опционы, GameFi, спот — 4 недели и 4 уровня сложности, каждая неделя уникальна!",
  jlfh: "Супер-фонд турнира всех звёзд BiKing: большие награды ждут вас — станьте богатым и знаменитым!",
  mh: "Бокс",
  cb: "Рейтинг",
  jy: "Торговля",
  syxxs: "Осталось звёзд",
  xxbhs: "Изменение количества звёзд",
  sjlx: "Тип события",
  jycp: "Торговый продукт",
  jye: "Объём торгов",
  myxgjl: "У вас пока нет соответствующих наград",
  jyhd: "Получено за торговлю",
  ql: "Сброс",
  kqmh: "Открыть бокс",
  yx: "GameFi",
  bchdyjs: "Акция завершена",
  gffjj: "Всего выплачено призов в этом турнире",
  kqmhsl: "Количество открытых боксов",
  cjjcjj: "Призовой фонд супер-бокса",
  cjjchjmd: "Список победителей супер-бокса",
  jjdyyh: "Приз зачислен на счёт пользователя",
  hdjj: "Полученный приз",
  wff: "Не выдано",
  mhhjjl: "История наград из боксов",
  cjdjhjjl: "История супер-призов",
  jjse: "Сумма приза",
  xhxxs: "Потрачено звёзд",
  bwqmxgz: "Правила турнира всех звёзд BiKing",
  hdnr: "Содержание акции",
  hdnrgz: "Супер-турнир всех звёзд BiKing охватывает бессрочные контракты, опционы, GameFi и спот. Акция длится 4 недели, каждую неделю открывается новый продукт. Получайте «звёзды» и выигрывайте щедрые призы. {total}% ежедневного фонда идёт на боксы, остальные {amount}% накапливаются до конца турнира и распределяются по рейтингу торговли!",
  hdjd: "Этапы акции",
  jbjs: "Постепенное открытие продуктов, 4 этапа",
  dyzq: "Первый этап",
  kqyxhy: "Запуск бессрочных контрактов: чем больше объём, тем больше звёзд и выше приз!",
  dezq: "Второй этап",
  jmqqjy: "Добавлены опционы: прибыль и убыток пополняют фонд, звёзд становится больше.",
  dszq: "Третий этап",
  cjgejc: "Подключена GameFi: новые способы получения звёзд и доступа к крупному фонду.",
  dsizq: "Четвёртый этап",
  gfzzdj: "Фонд боксов первых трёх недель остаётся открытым; отдельный рейтинг по споту — делёж финального приза!",
  jzszjs: "Расчёт призового фонда",
  jxmhgz1: "{amount}% ежедневного фонда направляется в боксы. Всего 100 боксов в день, 4 уровня призов. Неполученные награды переходят на следующий день. Особые боксы и боксы 1-го уровня обновляются ежедневно — высокий шанс выигрыша!",
  mhfpmx: "Всего боксов в день: {total}, что составляет {amount}% фонда. Распределение:",
  tjmhzb: "Особый бокс: {total} шт, {amount}% фонда",
  yjmhzb: "Бокс 1-го уровня: {total} шт, {amount}% фонда",
  ejmhzb: "Бокс 2-го уровня: {total} шт, {amount}% фонда",
  sjmhzb: "Бокс 3-го уровня: {total} шт, {amount}% фонда",
  kmhxxyq: "Требования к звёздам для открытия боксов: сумма дневного фонда боксов / {text}",
  tips: "Внимание: все награды в боксах обновляются ежедневно в 00:00 и рассчитываются на основе P&L предыдущего дня + остатка невостребованных наград. Распределение по уровням и пропорциям пересчитывается каждый день.",
  mrjyyk: "Общий фонд формируется из ежедневного P&L по бессрочным контрактам, опционам и GameFi.",
  mgyld: "Каждая прибыльная сделка: {amount}% = сумма прибыли × {amount}%",
  mrjcljdjs: "{amount}% ежедневного фонда накапливается до конца акции и распределяется между топ-3 в каждом из четырёх продуктов: бессрочные контракты 40%, опционы 30%, GameFi 20%, спот 10%.",
  yhhyyld: "Пример: прибыль по контракту 1000 USDT → 1000 × {amount}% = {total} USDT в дневной фонд",
  mgksd: "Каждая убыточная сделка: {amount}% = фактический убыток (убыток − восполнение просадки) × {amount}%",
  yhhyks: "Пример: убыток по контракту 1000 USDT → 1000 × {amount}% = {total} USDT в дневной фонд",
  qqhyyld: "Каждая прибыльная сделка (опционы): {amount}% = сумма ставки × коэффициент × {amount}%",
  qqyhddtz: "Пример: ставка 100 USDT по опциону на 10 секунд, выигрыш → 100 × 65% × {amount}% = {total} USDT в дневной фонд",
  qqhyksd: "Каждая убыточная сделка (опционы): {amount}% = сумма убытка × {amount}%",
  yhksjrjc: "Пример: убыток по опциону 100 USDT → 100 × {amount}% = {total} USDT в дневной фонд",
  yxyld: "Каждая прибыльная сделка GameFi: {amount}% = сумма ставки × коэффициент × {amount}%",
  yxddtz: "Пример: ставка 100 USDT в GameFi с коэффициентом 2x, выигрыш → 100 × 200% × {amount}% = {total} USDT в дневной фонд",
  yxmgksd: "Каждая убыточная сделка GameFi: {amount}% = сумма убытка × {amount}%",
  yhqqksd: "Пример: убыток по опциону 100 USDT → 100 × {amount}% = {total} USDT в дневной фонд",
  daiding: "Будет определено",
  yytz: "Корректировка акции",
  kaiqi: "Запуск",
  xhjyjrpm: "Спот-торговля включена в рейтинг",
  drjy: "Торговля сегодня → награда завтра",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/ru.js